export default __webpack_public_path__ + "static/media/admission2425.f11d18bd.jpg";